import { render, staticRenderFns } from "./hojasCDX.vue?vue&type=template&id=fb1e5420&scoped=true"
import script from "./hojasCDX.vue?vue&type=script&lang=js"
export * from "./hojasCDX.vue?vue&type=script&lang=js"
import style0 from "./hojasCDX.vue?vue&type=style&index=0&id=fb1e5420&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb1e5420",
  null
  
)

export default component.exports